/* IronPeak storefront enhancements — theme-hosted replacement for the legacy
   ironpeak-glitch.github.io cta-inject.js ScriptTag (product + home CTAs and
   FAQ/Product JSON-LD for SEO/AEO). Same-origin, version-controlled.
   Self-suppresses while the legacy GitHub ScriptTag is still installed, so it is
   safe to publish BEFORE removing that ScriptTag; it activates once the tag is gone. */
/**
 * IronPeak CTA Injector
 * Adds a "Calculate my profit" callout to product pages and homepage.
 * Hosted on GitHub Pages; attached to the Shopify store as a ScriptTag.
 * Safe to remove via Shopify Admin → Apps → Script tags.
 */
(function () {
  'use strict';
  if (document.querySelector('script[src*="ironpeak-glitch.github.io"]')) return; /* dedup: defer to legacy ScriptTag until it is removed */


  var CALC_URL = '/pages/profit-calculator';
  var body = document.body;

  /* ── Product page CTA bar ─────────────────────────────────────────── */
  var isProduct =
    body.classList.contains('template-product') ||
    window.location.pathname.indexOf('/products/') > -1;

  if (isProduct) {
    var form = document.querySelector('product-form form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
    if (form) {
      var help = document.createElement('p');
      help.className = 'ip-purchase-help';
      var link = document.createElement('a');
      link.href = CALC_URL;
      link.target = '_blank';
      link.rel = 'noopener';
      link.textContent = 'Calculate job profit (opens a new tab)';
      help.appendChild(link);
      form.insertAdjacentElement('afterend', help);
    }
  }

  /* ── Homepage calculator band ─────────────────────────────────────── */
  var isHome =
    body.classList.contains('template-index') ||
    window.location.pathname === '/';

  if (isHome) {
    var band = document.createElement('section');
    band.style.cssText =
      'background:#0E1116;padding:48px 24px;text-align:center;';
    band.innerHTML =
      '<div style="max-width:640px;margin:0 auto;">' +
        '<div style="color:#6FB1FF;font-size:12px;font-weight:700;' +
          'letter-spacing:.12em;text-transform:uppercase;margin-bottom:12px;">' +
          'Free Installer Tool' +
        '</div>' +
        '<div style="color:#E6E8EB;font-size:28px;font-weight:800;' +
          'letter-spacing:-.02em;margin-bottom:12px;line-height:1.25;">' +
          'See what permanent lighting pays you<br>before you spend a dollar' +
        '</div>' +
        '<div style="color:#8B949E;font-size:16px;margin-bottom:24px;">' +
          'No buy-in. No sales call. Just move two sliders and see your margin.' +
        '</div>' +
        '<a href="' + CALC_URL + '" ' +
          'style="display:inline-block;background:#2B7CF0;color:#fff;' +
          'text-decoration:none;padding:15px 32px;border-radius:10px;' +
          'font-weight:700;font-size:16px;">' +
          'Calculate my profit — free →' +
        '</a>' +
      '</div>';

    // Append inside <main>; fall back to body
    var mainEl = document.querySelector('main') || body;
    mainEl.appendChild(band);
  }
})();

/* Preserve first-touch attribution across standard Shopify pages. This block
   never submits a form and never loads a contact-creation pixel. */
(function () {
  'use strict';
  var KEY = 'iph_attr';
  var FIELDS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid'];
  try {
    var query = {};
    String(location.search || '').replace(/^\?/, '').split('&').forEach(function (part) {
      var pair = part.split('=');
      var name = decodeURIComponent(pair[0] || '').toLowerCase();
      if (FIELDS.indexOf(name) > -1) query[name] = decodeURIComponent((pair[1] || '').replace(/\+/g, ' ')).slice(0, 200);
    });
    var hasClick = Object.keys(query).length > 0;
    var stored = JSON.parse(localStorage.getItem(KEY) || 'null');
    if (!stored || (hasClick && !stored.has_click)) {
      var value = {
        ts: new Date().toISOString(),
        landing_url: location.href.slice(0, 500),
        referrer: (document.referrer || '').slice(0, 500),
        has_click: hasClick
      };
      FIELDS.forEach(function (name) { value[name] = query[name] || ''; });
      localStorage.setItem(KEY, JSON.stringify(value));
    }
  } catch (e) { /* storage/query parsing must not break storefront behavior */ }
})();

/* ── Structured data (JSON-LD) for SEO / AEO ──────────────────────────
 * Injects Product schema (from Shopify product meta) on product pages.
 * FAQ schema lives in each page's own visible FAQ. The shared JS-injected FAQ
 * was removed 2026-09-26: its answers were not visible on the pages it ran on,
 * and it duplicated the pages' own FAQPage blocks. Safe + additive.
 * ------------------------------------------------------------------- */
(function () {
  'use strict';
  if (document.querySelector('script[src*="ironpeak-glitch.github.io"]')) return; /* dedup: defer to legacy ScriptTag until it is removed */


  var body = document.body;

  function addJsonLd(obj) {
    try {
      var s = document.createElement('script');
      s.type = 'application/ld+json';
      s.text = JSON.stringify(obj);
      document.head.appendChild(s);
    } catch (e) { /* never break the page over schema */ }
  }

  var path = window.location.pathname;
  var isProduct = path.indexOf('/products/') > -1;

  if (isProduct) {
    /* Product schema from Shopify's product meta (price in cents) */
    try {
      var meta = (window.ShopifyAnalytics && window.ShopifyAnalytics.meta) || {};
      var p = meta.product;
      var og = function (prop) {
        var el = document.querySelector('meta[property="' + prop + '"]');
        return el ? el.getAttribute('content') : null;
      };
      if (p && p.variants && p.variants.length) {
        var prices = p.variants.map(function (v) { return v.price; });
        var low = Math.min.apply(null, prices) / 100;
        var high = Math.max.apply(null, prices) / 100;
        var cur = (meta.currency) || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
        var titleEl = document.querySelector('h1');
        var name = og('og:title') || (titleEl && titleEl.textContent.trim()) || p.type || 'IronPeak Product';
        var desc = og('og:description') || '';
        var img = og('og:image');
        var prod = {
          '@context': 'https://schema.org',
          '@type': 'Product',
          'name': name,
          'brand': { '@type': 'Brand', 'name': 'IronPeak Lighting' },
          'url': window.location.href.split('?')[0]
        };
        if (desc) prod.description = desc;
        if (img) prod.image = img;
        var offer = {
          '@type': (low === high ? 'Offer' : 'AggregateOffer'),
          'priceCurrency': cur,
          'availability': 'https://schema.org/InStock',
          'url': window.location.href.split('?')[0]
        };
        if (low === high) { offer.price = low.toFixed(2); }
        else { offer.lowPrice = low.toFixed(2); offer.highPrice = high.toFixed(2); }
        prod.offers = offer;
        addJsonLd(prod);
      }
    } catch (e) { /* ignore */ }
  }
})();

/* IronPeak installer locator — homeowner lead capture.
   Appended to assets/iph-storefront.js on an UNPUBLISHED theme. See docs/deploy.md.

   Contract (docs/routing-spec.md): one JSON POST to the WF-0 inbound webhook.
   - Activates only when a form[data-iph-locator] is on the page; otherwise it does nothing.
   - Never throws at load, never blocks another script, never touches the rest of the storefront.
   - A homeowner never sees a dead button: a failed send shows the founder's email and keeps
     everything they typed.
   The WEBHOOK constant below is substituted at build time with the public GHL inbound
   trigger URL, so the URL itself is never committed. */
(function () {
  'use strict';

  var WEBHOOK = 'https://services.leadconnectorhq.com/hooks/99eVuuXW11CRRtiGwcXE/webhook-trigger/5b7b3d77-8087-4f57-999f-a13bf0580e0c';
  var ATTR_KEY = 'iph_attr';
  var ATTR_FIELDS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid'];

  // Bound by delegation on the document, in the capture phase: the handler works whether
  // this script runs before or after the form is parsed, and whether the form was rendered
  // by the theme or injected later. Load order cannot break it.
  var wired = [];

  // ---------------------------------------------------------------- helpers
  function cfgOf(form) {
    try { return JSON.parse(form.getAttribute('data-iph-locator')) || {}; }
    catch (e) { return {}; }
  }

  function attribution() {
    var out = {};
    var stored = null;
    try { stored = JSON.parse(localStorage.getItem(ATTR_KEY) || 'null'); } catch (e) { /* private mode */ }
    if (stored) {
      for (var i = 0; i < ATTR_FIELDS.length; i++) {
        var k = ATTR_FIELDS[i];
        if (stored[k]) out[k] = String(stored[k]).slice(0, 200);
      }
      if (stored.landing_url) out.landing_url = String(stored.landing_url).slice(0, 500);
      if (stored.referrer) out.referrer = String(stored.referrer).slice(0, 500);
      if (stored.ts) out.first_touch_at = stored.ts;
    }
    // This page's own query string wins for a click that just landed.
    try {
      var q = new URLSearchParams(location.search);
      for (var j = 0; j < ATTR_FIELDS.length; j++) {
        var f = ATTR_FIELDS[j];
        var v = q.get(f);
        if (v) out[f] = v.slice(0, 200);
      }
    } catch (e) { /* no URLSearchParams */ }
    var paid = !!(out.gclid || out.fbclid || /cpc|ppc|paid|display/i.test(out.utm_medium || ''));
    out.paid_ad = paid ? 'yes' : 'no';
    return out;
  }

  function normPhone(raw) {
    var d = String(raw || '').replace(/[^0-9]/g, '');
    if (d.length === 11 && d.charAt(0) === '1') d = d.slice(1);
    return d.length === 10 ? '+1' + d : '';
  }

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i;

  function zipInRanges(zip, ranges) {
    if (!ranges || !ranges.length) return null; // unknown, not false
    var p = parseInt(zip.slice(0, 3), 10);
    for (var i = 0; i < ranges.length; i++) {
      if (p >= ranges[i][0] && p <= ranges[i][1]) return true;
    }
    return false;
  }

  // zip_in_area is a promise made to the installer, so it is never guessed.
  //   'yes'      he has confirmed a ZIP list and this ZIP is on it
  //   'unknown'  in his state, but nobody has confirmed the service area yet
  //   'no'       in his state but outside his confirmed list — still his lead, flagged to confirm
  //   serviceable:false  outside the state entirely — goes to the waiting pool
  // routing-spec.md §3: an in-state ZIP always reaches the installer, because he is the only
  // one who can say whether he'll drive it. Out of state has no installer to reach.
  function areaOf(zip, cfg) {
    var inState = zipInRanges(zip, cfg.zip_prefix_ranges);   // true | false | null
    if (inState === false) return { serviceable: false, flag: 'no' };
    var allow = cfg.zip_allowlist || [];
    if (!allow.length) return { serviceable: true, flag: 'unknown' };
    return { serviceable: true, flag: allow.indexOf(zip) > -1 ? 'yes' : 'no' };
  }

  function slugify(s) {
    return String(s).toLowerCase().trim()
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60);
  }

  function show(el, html, kind) {
    if (!el) return;
    el.innerHTML = html;
    el.className = 'iph-status' + (kind ? ' iph-status--' + kind : '');
    el.hidden = false;
  }

  function fail(form, cfg, status, values) {
    var email = cfg.support_email || 'devan@ironpeaklighting.com';
    show(status,
      '<p><strong>That didn\'t send.</strong> Nothing was lost — your details are still in the form above.</p>' +
      '<p>Email me directly at <a href="mailto:' + email + '">' + email + '</a> with your ZIP and your number, ' +
      'and I\'ll route it to the installer myself.</p>', 'err');
    if (values) { try { console.warn('[iph-locator] send failed'); } catch (e) {} }
  }

  // ---------------------------------------------------------------- payload
  function buildPayload(form, cfg) {
    var get = function (n) {
      var el = form.querySelector('[name="' + n + '"]');
      if (!el) return '';
      if (el.type === 'checkbox') return el.checked ? el.value : 'no';
      return String(el.value || '').trim();
    };

    var name = get('name');
    var zip = get('postal_code');
    var area = areaOf(zip, cfg);
    var route = cfg.route === 'dealer' && area.serviceable ? 'dealer' : 'waiting';

    var citySlug = cfg.city_slug || '';
    var city = cfg.city || '';
    var state = cfg.state || '';
    if (cfg.mode === 'hub') {
      var typed = get('city_query');
      citySlug = slugify(typed);
      city = typed;
      state = '';
      route = 'waiting';
    }

    var parts = name.split(/\s+/);
    var payload = {
      source: cfg.source || 'IronPeak Installer Locator',
      lead_type: 'homeowner',
      name: name,
      first_name: parts[0] || '',
      last_name: parts.slice(1).join(' '),
      email: get('email'),
      phone: normPhone(get('phone')),
      sms_consent: get('sms_consent') === 'yes' ? 'yes' : 'no',
      postal_code: zip,
      city: city,
      state: state,
      route: route,
      zip_in_area: area.flag,
      city_slug: citySlug,
      dealer_id: route === 'dealer' ? (cfg.dealer_id || '') : '',
      dealer_slug: route === 'dealer' ? (cfg.dealer_slug || '') : '',
      dealer_name: route === 'dealer' ? (cfg.dealer_name || '') : '',
      page_url: location.href.split('#')[0].slice(0, 500),
      address1: get('address1'),
      roofline_estimate: get('roofline_estimate'),
      install_timeline: get('install_timeline'),
      homeowner_message: get('homeowner_message').slice(0, 1200)
    };

    var attr = attribution();
    for (var k in attr) if (Object.prototype.hasOwnProperty.call(attr, k)) payload[k] = attr[k];

    // WF-0 merges on "field absent" — an empty string would wipe a stored value.
    for (var key in payload) {
      if (Object.prototype.hasOwnProperty.call(payload, key) && payload[key] === '') delete payload[key];
    }
    return payload;
  }

  // ---------------------------------------------------------------- validate
  function validate(form, cfg, waitingOpen) {
    var need = cfg.mode === 'hub'
      ? (waitingOpen ? ['name', 'email', 'phone', 'postal_code'] : ['city_query'])
      : ['name', 'email', 'phone', 'postal_code'];

    for (var i = 0; i < need.length; i++) {
      var n = need[i];
      var el = form.querySelector('[name="' + n + '"]');
      var v = el ? String(el.value || '').trim() : '';
      if (!v) return { ok: false, field: n, msg: labelFor(n) + ' is required.' };
      if (n === 'email' && !EMAIL_RE.test(v)) return { ok: false, field: n, msg: 'That email address doesn\'t look right.' };
      if (n === 'phone' && !normPhone(v)) return { ok: false, field: n, msg: 'Enter a 10-digit US mobile number — the installer calls you back on it.' };
      if (n === 'postal_code' && !/^[0-9]{5}$/.test(v)) return { ok: false, field: n, msg: 'Enter a 5-digit ZIP code.' };
    }
    return { ok: true };
  }

  function labelFor(n) {
    return { name: 'Your name', email: 'Email', phone: 'Mobile number', postal_code: 'ZIP code', city_query: 'Your city' }[n] || 'This field';
  }

  // ---------------------------------------------------------------- wire up
  function onSubmit(ev) {
    var form = ev.target && ev.target.closest ? ev.target.closest('form[data-iph-locator]') : null;
    if (!form) return;                       // not ours — leave every other form alone
    ev.preventDefault();

    var cfg = cfgOf(form);
    var status = form.querySelector('[data-iph-status]');
    var errEl = form.querySelector('[data-iph-error]');
    var waitingBlock = form.querySelector('[data-iph-waiting]');
    if (form.__iphSending) return;
    if (errEl) errEl.hidden = true;

    // Honeypot: a bot filled the hidden field. Look successful, send nothing.
    var hp = form.querySelector('[name="website"]');
    if (hp && hp.value) { show(status, '<p>Thanks — that\'s on its way.</p>', 'ok'); return; }

    var waitingOpen = !!(waitingBlock && !waitingBlock.hidden);

    // Hub, first press: try to match the typed city to a page.
    if (cfg.mode === 'hub' && !waitingOpen) {
      var v0 = validate(form, cfg, false);
      if (!v0.ok) { if (errEl) { errEl.textContent = v0.msg; errEl.hidden = false; } return; }
      var typed = String(form.querySelector('[name="city_query"]').value || '').trim();
      var want = slugify(typed);
      var list = cfg.cities || [];
      var hit = null;
      for (var i = 0; i < list.length; i++) {
        var c = list[i];
        var full = slugify(c.city + '-' + c.state);
        if (want === full || want === slugify(c.city) || want === c.slug || full.indexOf(want) === 0) { hit = c; break; }
      }
      if (hit) { location.href = '/pages/' + hit.handle; return; }
      if (waitingBlock) {
        waitingBlock.hidden = false;
        var firstInput = waitingBlock.querySelector('input');
        if (firstInput) firstInput.focus();
      }
      show(status, '<p>No installer covers <strong>' + (typed.replace(/[<>&]/g, '') || 'that area') +
        '</strong> yet. Add your details and you go on the list for it — I contact you the day someone signs on nearby.</p>', null);
      return;
    }

    var v = validate(form, cfg, waitingOpen);
    if (!v.ok) {
      if (errEl) { errEl.textContent = v.msg; errEl.hidden = false; }
      var bad = form.querySelector('[name="' + v.field + '"]');
      if (bad) bad.focus();
      return;
    }

    var payload = buildPayload(form, cfg);
    var btn = form.querySelector('button[type="submit"]');
    var btnText = btn ? btn.textContent : '';
    form.__iphSending = true;
    if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }

    fetch(WEBHOOK, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      var email = cfg.support_email || 'devan@ironpeaklighting.com';
      var who = payload.route === 'dealer' && cfg.dealer_name
        ? '<p><strong>Sent to ' + cfg.dealer_name + '.</strong> ' + (cfg.dealer_first_name || 'They') +
          ' has your request now, and a copy landed with me.</p>' +
          '<p>If you haven\'t heard back within 2 business days, email me at <a href="mailto:' +
          email + '">' + email + '</a> and I\'ll chase it myself.</p>'
        : '<p><strong>You\'re on the list.</strong> No installer covers your area yet, so your request sits with me — not in a marketing sequence.</p>' +
          '<p>I\'ll email you the day an installer signs on near you, or sooner if I can route it to someone within driving distance.</p>';
      show(status, who, 'ok');
      var fields = form.querySelectorAll('input, select, textarea');
      for (var k = 0; k < fields.length; k++) {
        if (fields[k].type === 'checkbox') fields[k].checked = false; else fields[k].value = '';
      }
      if (waitingBlock) waitingBlock.hidden = true;
    }).catch(function () {
      fail(form, cfg, status, payload);
    }).then(function () {
      form.__iphSending = false;
      if (btn) { btn.disabled = false; btn.textContent = btnText; }
    });
  }

  document.addEventListener('submit', onSubmit, true);

  // Tell an out-of-area visitor before they submit, not after.
  document.addEventListener('blur', function (ev) {
    var el = ev.target;
    if (!el || el.name !== 'postal_code' || !el.closest) return;
    var form = el.closest('form[data-iph-locator]');
    if (!form) return;
    var cfg = cfgOf(form);
    var note = form.querySelector('[data-iph-zipnote]');
    if (!note || cfg.route !== 'dealer') return;
    var z = String(el.value || '').trim();
    if (!/^[0-9]{5}$/.test(z)) { note.hidden = true; return; }
    if (!areaOf(z, cfg).serviceable) {
      note.textContent = 'That ZIP is outside ' + (cfg.state_name || 'the area') +
        ', so no installer covers it yet. Send it anyway and I\'ll put you on the list for your area.';
      note.hidden = false;
    } else { note.hidden = true; }
  }, true);
})();
